(function () {
  if (window.__rsgClickMenus) return;
  window.__rsgClickMenus = true;

  var makesScrollBound = false;

  function getPanel(item) {
    if (!item) return null;
    if (item._rsgPanel && item._rsgPanel.isConnected) return item._rsgPanel;
    var panel = item.querySelector(':scope > .rsg-makes__panel');
    if (panel) item._rsgPanel = panel;
    return panel;
  }

  function isTopMake(item) {
    return Boolean(item && item.parentElement && item.parentElement.classList.contains('rsg-makes__bar'));
  }

  function getPortal() {
    var el = document.getElementById('RsgMakesPortal');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'RsgMakesPortal';
    document.body.appendChild(el);
    return el;
  }

  function applyPortaled() {
    var sx = window.pageXOffset || document.documentElement.scrollLeft || 0;
    var sy = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.querySelectorAll('#RsgMakesPortal .rsg-makes__panel.is-ported').forEach(function (panel) {
      var d = panel.__rsgDoc;
      if (!d) return;
      panel.style.top = d.y - sy + 'px';
      panel.style.left = d.x - sx + 'px';
    });
  }

  function syncPortaledScroll() {
    var open = Boolean(document.querySelector('.rsg-makes__bar > .rsg-makes__item.is-open'));
    if (open) {
      if (!makesScrollBound) {
        makesScrollBound = true;
        window.addEventListener('scroll', applyPortaled, { passive: true });
      }
      applyPortaled();
      return;
    }
    if (makesScrollBound) {
      window.removeEventListener('scroll', applyPortaled);
      makesScrollBound = false;
    }
  }

  function releasePanel(item) {
    var panel = getPanel(item);
    if (!panel || !panel.classList.contains('is-ported')) return;
    var home = panel.__rsgHome;
    panel.classList.remove('is-ported');
    panel.style.position = '';
    panel.style.top = '';
    panel.style.left = '';
    panel.style.right = '';
    panel.style.bottom = '';
    panel.style.display = '';
    delete panel.__rsgDoc;
    if (home && home.parent) {
      if (home.next && home.next.parentNode === home.parent) home.parent.insertBefore(panel, home.next);
      else home.parent.appendChild(panel);
    }
    delete panel.__rsgHome;
  }

  function placePortaled(item) {
    var panel = getPanel(item);
    var trigger = item.querySelector(':scope > [data-rsg-menu-trigger], :scope > .rsg-makes__trigger');
    if (!panel || !trigger) return;
    var portal = getPortal();
    if (panel.parentElement !== portal) {
      panel.__rsgHome = { parent: item, next: panel.nextSibling };
      portal.appendChild(panel);
    }
    panel.classList.add('is-ported');
    var tr = trigger.getBoundingClientRect();
    var sx = window.pageXOffset || document.documentElement.scrollLeft || 0;
    var sy = window.pageYOffset || document.documentElement.scrollTop || 0;
    var x = tr.left + sx;
    var y = tr.bottom + sy;
    panel.style.position = 'fixed';
    panel.style.display = 'block';
    panel.style.right = 'auto';
    panel.style.bottom = 'auto';
    panel.style.top = tr.bottom + 'px';
    panel.style.left = tr.left + 'px';
    var rect = panel.getBoundingClientRect();
    if (rect.right > window.innerWidth - 8) {
      x = tr.right + sx - rect.width;
      panel.style.left = tr.right - rect.width + 'px';
    }
    panel.__rsgDoc = { x: x, y: y };
  }

  function closeTree(item) {
    if (!item) return;
    item.classList.remove('is-open', 'is-flip-x', 'is-flip-y');
    item.querySelectorAll('.is-open').forEach(function (el) {
      el.classList.remove('is-open', 'is-flip-x', 'is-flip-y');
      var nested = el.querySelector(':scope > [aria-expanded="true"]');
      if (nested) nested.setAttribute('aria-expanded', 'false');
    });
    var trigger = item.querySelector(':scope > [aria-expanded]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (isTopMake(item)) releasePanel(item);
  }

  function closeAll() {
    document.querySelectorAll('.rsg-makes__item.is-open').forEach(closeTree);
    document.body.classList.remove('rsg-menu-open');
    syncPortaledScroll();
  }

  function syncBody() {
    document.body.classList.toggle(
      'rsg-menu-open',
      Boolean(document.querySelector('.rsg-makes__item.is-open'))
    );
    syncPortaledScroll();
  }

  function alignPanel(item) {
    var panel = getPanel(item);
    if (!panel) return;
    if (isTopMake(item)) {
      placePortaled(item);
      return;
    }
    item.classList.remove('is-flip-x', 'is-flip-y');
    panel.style.maxHeight = '';
    var filled = panel.getAttribute('data-rsg-filled') === '1';
    var rect = panel.getBoundingClientRect();
    if (rect.right > window.innerWidth - 8) item.classList.add('is-flip-x');
    if (!filled && rect.bottom > window.innerHeight - 8) item.classList.add('is-flip-y');
  }

  function getSubsMap() {
    if (window.__rsgMakesSubs) return window.__rsgMakesSubs;
    var el = document.getElementById('RsgMakesSubs');
    try {
      window.__rsgMakesSubs = el ? JSON.parse(el.textContent) : {};
    } catch (err) {
      window.__rsgMakesSubs = {};
    }
    return window.__rsgMakesSubs;
  }

  function getEngineMap() {
    if (window.__rsgEngineCollections) return window.__rsgEngineCollections;
    var el = document.getElementById('RsgEngineCollectionMap');
    try {
      window.__rsgEngineCollections = el ? JSON.parse(el.textContent) : {};
    } catch (err) {
      window.__rsgEngineCollections = {};
    }
    return window.__rsgEngineCollections;
  }

  function rsgSlug(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/&/g, ' ')
      .replace(/\//g, ' ')
      .replace(/\+/g, ' ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function getRealstParents() {
    if (window.__rsgEngineRealstParents) return window.__rsgEngineRealstParents;
    var el = document.getElementById('RsgEngineRealstParents');
    try {
      window.__rsgEngineRealstParents = el ? JSON.parse(el.textContent) : {};
    } catch (err) {
      window.__rsgEngineRealstParents = {};
    }
    return window.__rsgEngineRealstParents;
  }

  function getEngineFilterTokens() {
    if (window.__rsgEngineFilterTokens) return window.__rsgEngineFilterTokens;
    var el = document.getElementById('RsgEngineFilterTokens');
    try {
      window.__rsgEngineFilterTokens = el ? JSON.parse(el.textContent) : {};
    } catch (err) {
      window.__rsgEngineFilterTokens = {};
    }
    return window.__rsgEngineFilterTokens;
  }

  function clearanceUrlForEngine(base, engine) {
    if (!base) return '';
    var token = (getEngineFilterTokens() || {})[engine];
    if (!token) return base;
    var join = base.indexOf('?') === -1 ? '?' : '&';
    return base + join + 'filter.p.m.custom.engine=' + encodeURIComponent(token);
  }

  function engineCfg() {
    var map = getEngineMap() || {};
    return {
      engines: Array.isArray(map.engines) ? map.engines : Object.keys(map),
      parts: map.parts || null,
      legacy: map.parts ? null : map,
      smartLeaves: map.smartLeaves || null,
      largeParents: map.largeParents || [],
      smartHubs: map.smartHubs || [],
      subMap: map.subMap || {},
      engineParents: getRealstParents(),
    };
  }

  function hasEngineCollections(engine) {
    if (!engine) return false;
    var cfg = engineCfg();
    return cfg.engines.indexOf(engine) !== -1;
  }

  function sharedLeafUrl(catKey, menuTitle) {
    var generic = (getSubsMap()[catKey] || []).filter(function (row) {
      return row && row.title === menuTitle && row.url;
    })[0];
    return generic ? generic.url : '';
  }

  function isLargeParentLeaf(catKey, menuTitle) {
    var rows = engineCfg().largeParents || [];
    for (var i = 0; i < rows.length; i += 1) {
      if (rows[i] && rows[i].cat_key === catKey && rows[i].menu === menuTitle) return true;
    }
    return false;
  }

  function engineLeafUrl(engine, catKey, menuTitle) {
    // Race oils are catalog-wide (Engine=Universal). Shared manuals, no engine AND.
    if (catKey === 'race-oils') return sharedLeafUrl(catKey, menuTitle);
    var cfg = engineCfg();
    if (cfg.parts && cfg.parts[catKey]) {
      var smart = (((cfg.smartLeaves || {})[engine] || {})[catKey] || []);
      if (isLargeParentLeaf(catKey, menuTitle) || (cfg.smartLeaves && smart.indexOf(menuTitle) !== -1)) {
        return '/collections/' + rsgSlug(engine + ' - ' + cfg.parts[catKey] + ' - ' + menuTitle);
      }
      // Empty / not-yet-smart leaves on parents under 5k: shared subcategory + engine filter.
      return clearanceUrlForEngine(sharedLeafUrl(catKey, menuTitle), engine);
    }
    var rows = ((cfg.legacy || {})[engine] || {})[catKey] || [];
    for (var i = 0; i < rows.length; i += 1) {
      if (rows[i] && rows[i].title === menuTitle) return rows[i].url || '';
    }
    return '';
  }

  function engineHubUrl(engine, hubKey) {
    var cfg = engineCfg();
    if (cfg.parts) {
      if ((cfg.smartHubs || []).indexOf(engine) !== -1) {
        return '/collections/' + rsgSlug(engine + ' - Engine & Transmission Mounts');
      }
      var part = cfg.parts['bottom-end-engine-parts'] || 'Bottom End Engine Parts';
      return (
        '/collections/' +
        rsgSlug(engine + ' - ' + part) +
        '?filter.p.m.custom.sub_category=' +
        encodeURIComponent('Engine & Transmission Mounts')
      );
    }
    return ((((cfg.legacy || {})[engine] || {}).hubs) || {})[hubKey] || '';
  }

  function engineLabelFor(item) {
    var engineItem = item && item.closest('[data-rsg-engine]');
    return engineItem ? (engineItem.getAttribute('data-rsg-engine') || '').trim() : '';
  }

  function usableRows(rows) {
    return (rows || []).filter(function (row) {
      if (!row || !row.url) return false;
      var title = String(row.title || '').toLowerCase();
      return title.indexOf('package builder') === -1 && title.indexOf('clearance') === -1;
    });
  }

  function applyEngineHubs(item) {
    var engine = item && item.getAttribute('data-rsg-engine');
    if (!engine || !hasEngineCollections(engine)) return;
    var panel = getPanel(item);
    if (!panel) return;
    panel.querySelectorAll('a[data-rsg-engine-hub]').forEach(function (a) {
      var url = engineHubUrl(engine, a.getAttribute('data-rsg-engine-hub'));
      if (url) a.setAttribute('href', url);
    });
  }

  function caretSvg() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 12 12');
    svg.setAttribute('width', '10');
    svg.setAttribute('height', '10');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M4.5 2.5L8 6l-3.5 3.5');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.5');
    svg.appendChild(path);
    return svg;
  }

  var CAT_ORDER = [
    { key: 'intake-exhaust', title: 'Intake & Exhaust', kind: 'subs' },
    { key: 'bottom-end-engine-parts', title: 'Bottom End Engine Parts', kind: 'subs' },
    { key: 'top-end-engine-parts', title: 'Top End Engine Parts', kind: 'subs' },
    { key: 'race-oils', title: 'Race Oils', kind: 'subs' },
    { key: 'fuel-system-parts', title: 'Fuel System Parts', kind: 'subs' },
    { key: 'engine-management-ignition', title: 'Engine Management & Ignition', kind: 'subs' },
    { key: 'turbo-system-parts', title: 'Turbo System Parts', kind: 'subs' },
    { key: 'engine-transmission-mounts', title: 'Engine & Transmission Mounts', kind: 'hub' },
    { key: 'clutch-drivetrain', title: 'Clutch & Drivetrain', kind: 'subs' },
    { key: 'nitrous-system-parts', title: 'Nitrous System Parts', kind: 'subs' },
    { key: 'cooling-system-parts', title: 'Cooling System Parts', kind: 'subs' },
    { key: 'suspension-parts', title: 'Suspension Parts', kind: 'subs' },
    { key: 'brakes', title: 'Brakes', kind: 'subs' },
    { key: 'wheels', title: 'Wheels', kind: 'subs' },
  ];

  var TITLE_TO_CAT = {
    'intake & exhaust': 'intake-exhaust',
    'intake and exhaust': 'intake-exhaust',
    'bottom end engine parts': 'bottom-end-engine-parts',
    'top end engine parts': 'top-end-engine-parts',
    'race oils': 'race-oils',
    'fuel system parts': 'fuel-system-parts',
    'engine management & ignition': 'engine-management-ignition',
    'engine management and ignition': 'engine-management-ignition',
    'engine management': 'engine-management-ignition',
    'turbo system parts': 'turbo-system-parts',
    'turbo parts': 'turbo-system-parts',
    'engine & transmission mounts': 'engine-transmission-mounts',
    'engine and transmission mounts': 'engine-transmission-mounts',
    'engine transmission & mounts': 'engine-transmission-mounts',
    'clutch & drivetrain': 'clutch-drivetrain',
    'clutch/drive train': 'clutch-drivetrain',
    'nitrous system parts': 'nitrous-system-parts',
    'nitrous system': 'nitrous-system-parts',
    'cooling system parts': 'cooling-system-parts',
    'cooling system': 'cooling-system-parts',
    'suspension parts': 'suspension-parts',
    'suspension': 'suspension-parts',
    'brakes': 'brakes',
    'wheels': 'wheels',
  };

  function shopifyEngineKeys(panel) {
    var keys = {};
    if (!panel) return keys;
    panel.querySelectorAll('[data-rsg-subs]').forEach(function (el) {
      var key = el.getAttribute('data-rsg-subs');
      if (key) keys[key] = true;
    });
    panel.querySelectorAll('[data-rsg-engine-hub]').forEach(function (el) {
      var key = el.getAttribute('data-rsg-engine-hub');
      if (key) keys[key] = true;
    });
    panel.querySelectorAll(':scope > li').forEach(function (li) {
      var label = li.querySelector(':scope > [data-rsg-menu-trigger] span, :scope > .rsg-makes__link');
      var title = ((label && label.textContent) || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var key = TITLE_TO_CAT[title];
      if (key) keys[key] = true;
    });
    return keys;
  }

  function engineCatRows(engine, panel, cfg) {
    var magento = (cfg.engineParents || {})[engine];
    if (magento && magento.length) {
      var magentoKeys = {};
      magento.forEach(function (key) {
        magentoKeys[key] = true;
      });
      return CAT_ORDER.filter(function (row) {
        return magentoKeys[row.key];
      });
    }
    var keys = shopifyEngineKeys(panel);
    ['bottom-end-engine-parts', 'top-end-engine-parts', 'engine-transmission-mounts'].forEach(function (key) {
      keys[key] = true;
    });
    var smart = ((cfg.smartLeaves || {})[engine]) || {};
    Object.keys(smart).forEach(function (key) {
      keys[key] = true;
    });
    return CAT_ORDER.filter(function (row) {
      return keys[row.key];
    });
  }

  function fillEngineCats(item) {
    if (!item || !item.hasAttribute('data-rsg-engine')) return;
    var engine = (item.getAttribute('data-rsg-engine') || '').trim();
    var cfg = engineCfg();
    var magento = (cfg.engineParents || {})[engine] || [];
    if (!hasEngineCollections(engine) && !magento.length) return;
    var panel = getPanel(item);
    if (!panel || panel.getAttribute('data-rsg-engine-filled') === '1') return;
    var rows = engineCatRows(engine, panel, cfg);
    panel.textContent = '';
    var root = item.closest('.rsg-makes');
    var clearance = root && root.getAttribute('data-rsg-clearance-url');
    if (clearance) {
      var cli = document.createElement('li');
      cli.setAttribute('role', 'none');
      var ca = document.createElement('a');
      ca.className = 'rsg-makes__link rsg-makes__link--clearance';
      ca.setAttribute('role', 'menuitem');
      ca.href = clearanceUrlForEngine(clearance, engine);
      ca.textContent = '*Clearance Sale Items';
      cli.appendChild(ca);
      panel.appendChild(cli);
    }
    rows.forEach(function (row) {
      var li = document.createElement('li');
      if (row.kind === 'hub') {
        li.setAttribute('role', 'none');
        var a = document.createElement('a');
        a.className = 'rsg-makes__link';
        a.setAttribute('role', 'menuitem');
        a.setAttribute('data-rsg-engine-hub', row.key);
        a.href = engineHubUrl(engine, row.key) || '#';
        a.textContent = row.title;
        li.appendChild(a);
        panel.appendChild(li);
        return;
      }
      li.className = 'rsg-makes__item';
      li.setAttribute('role', 'none');
      li.setAttribute('data-rsg-subs', row.key);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rsg-makes__link rsg-makes__link--parent';
      btn.setAttribute('role', 'menuitem');
      btn.setAttribute('aria-haspopup', 'true');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('data-rsg-menu-trigger', '');
      var span = document.createElement('span');
      span.textContent = row.title;
      btn.appendChild(span);
      btn.appendChild(caretSvg());
      var fly = document.createElement('ul');
      fly.className = 'rsg-makes__panel rsg-makes__panel--flyout';
      fly.setAttribute('role', 'menu');
      fly.setAttribute('aria-label', row.title);
      li.appendChild(btn);
      li.appendChild(fly);
      panel.appendChild(li);
    });
    panel.setAttribute('data-rsg-engine-filled', '1');
  }

  function fillSubs(item) {
    if (!item || !item.hasAttribute('data-rsg-subs')) return;
    var panel = getPanel(item);
    if (!panel || panel.getAttribute('data-rsg-filled') === '1') return;
    var key = item.getAttribute('data-rsg-subs');
    var engine = engineLabelFor(item);
    var generic = getSubsMap()[key] || [];
    var rows;
    if (hasEngineCollections(engine) && key !== 'race-oils') {
      rows = generic.map(function (row) {
        return { title: row.title, url: engineLeafUrl(engine, key, row.title) };
      });
    } else {
      rows = generic;
    }
    rows = usableRows(rows);
    panel.textContent = '';
    rows.forEach(function (row) {
      var li = document.createElement('li');
      li.setAttribute('role', 'none');
      var a = document.createElement('a');
      a.className = 'rsg-makes__link';
      a.setAttribute('role', 'menuitem');
      a.href = row.url;
      a.textContent = row.title;
      li.appendChild(a);
      panel.appendChild(li);
    });
    panel.setAttribute('data-rsg-filled', '1');
  }

  function openItem(item) {
    var parent = item.parentElement;
    if (parent) {
      parent.querySelectorAll(':scope > .is-open').forEach(function (sib) {
        if (sib !== item) closeTree(sib);
      });
    }
    fillEngineCats(item);
    applyEngineHubs(item);
    fillSubs(item);
    item.classList.add('is-open');
    var trigger = item.querySelector(':scope > [aria-haspopup]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    alignPanel(item);
    syncBody();
  }

  function toggleItem(item) {
    if (item.classList.contains('is-open')) {
      closeTree(item);
      syncBody();
    } else {
      openItem(item);
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-rsg-menu-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      toggleItem(trigger.parentElement);
      return;
    }
    if (!e.target.closest('.rsg-makes, #RsgMakesPortal')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  window.addEventListener('resize', closeAll);

  function syncSearchOpen() {
    var open = Boolean(document.querySelector('.header__search details[open]'));
    document.body.classList.toggle('rsg-search-open', open);
    if (open) closeAll();
  }

  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.closest && e.target.closest('.header__search')) syncSearchOpen();
  }, true);

  window.__rsgCloseMakes = closeAll;

  document.querySelectorAll('[data-rsg-engine]').forEach(fillEngineCats);

  function lockMakesEngineFilter() {
    var params = new URLSearchParams(window.location.search);
    var engine = params.get('filter.p.m.custom.engine');
    if (!engine) return;
    function withEngine(href) {
      if (!href) return href;
      try {
        var u = new URL(href, window.location.origin);
        u.searchParams.set('filter.p.m.custom.engine', engine);
        return u.pathname + u.search + u.hash;
      } catch (err) {
        return href;
      }
    }
    document.querySelectorAll('form#FacetFiltersForm, form#FacetFiltersFormMobile').forEach(function (form) {
      if (form.querySelector('input[name="filter.p.m.custom.engine"][data-rsg-engine-lock]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'filter.p.m.custom.engine';
      input.value = engine;
      input.setAttribute('data-rsg-engine-lock', '1');
      form.appendChild(input);
    });
    document.querySelectorAll('[id*="filter.p.m.custom.engine"]').forEach(function (el) {
      var hide = el.closest('details, .filter-panel, .mobile-facets__details, .js-filter') || el;
      hide.style.display = 'none';
    });
    document.querySelectorAll('.active-facets__button, .active-facets__button-remove, .facets__reset').forEach(function (a) {
      var text = (a.textContent || '').replace(/\s+/g, ' ');
      if (/Engine\s*:/i.test(text)) {
        var wrap = a.closest('facet-remove') || a;
        wrap.style.display = 'none';
        return;
      }
      if (a.hasAttribute('href')) a.setAttribute('href', withEngine(a.getAttribute('href')));
    });
    document.querySelectorAll('.collection--empty a.underlined-link').forEach(function (a) {
      a.setAttribute('href', withEngine(a.getAttribute('href')));
    });
  }

  function bindEngineFilterLock() {
    lockMakesEngineFilter();
    var root = document.querySelector('main') || document.body;
    if (!root || root.__rsgEngineLockObs || !window.MutationObserver) return;
    var t;
    root.__rsgEngineLockObs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(lockMakesEngineFilter, 50);
    });
    root.__rsgEngineLockObs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindEngineFilterLock);
  } else {
    bindEngineFilterLock();
  }
})();
